/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./En.css";
import { Link, Redirect } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";
import { DONOR_AUTH, ORG_AUTH, PLATFORM } from "../../config";
import { checkLoginStatus } from "../../assets/helper";
import PlugEn from "../PlugEn/PlugEn";

class En extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  render() {
    // Platform conditional rendering. On Plug the homepage is the marketing
    // site, not the marketplace — the marketplace is where its sign-up and
    // "Browse nonprofits" buttons lead, at /webapp (CP-318).
    //
    // Except for a session that is already signed in. This path used to render
    // the marketplace, which opens the workspace an org or donor belongs to;
    // handing them marketing copy and a "Log in" button instead loses them the
    // way back to their own dashboard. The site keeps its own paths (/PlugEn
    // and friends), so it is still readable while signed in.
    if (PLATFORM === "plug") {
      if (checkLoginStatus(ORG_AUTH) || checkLoginStatus(DONOR_AUTH)) {
        return <Redirect to="/webapp" />;
      }
      return <PlugEn {...this.props} />;
    }

    // Existing CheckPlus implementation
    return (
      <div className="En-view">
        <Helmet>
          <title>CheckPlus</title>
        </Helmet>

        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="En-first">
          <div className="En-firstContainer">
            <div className="En-first-content">
              <div className="En-first-picture" />
              <div className="En-first-text">
                <div className="En-heading">Automate your nonprofit today.</div>

                <div className="En-noteTxt">
                  Please note your organization needs to be a nonprofit
                  registered in Hong Kong under Section 88 in order to be
                  eligible for CheckPlus for Nonprofit.
                </div>

                <Link to="/EnVideo">
                  <div className="En-supportOrgNextContainer">
                    <div className="En-supportOrgNextText">Watch the film</div>
                    <div className="En-supportOrgNextArrow"></div>
                  </div>
                </Link>
              </div>

              <div className="En-awardsOuterContainer">
                <div className="En-trophyContainer">
                  <div className="En-trophyIcn" />
                  <div className="En-trophyTxt">Award Recognitions</div>
                </div>
                <div className="En-awards" />
              </div>

              <div className="En-awardsOuterContainer">
                <div className="En-trophyContainer">
                  <div className="En-pressIcn" />
                  <div className="En-pressTxt">Media Coverage</div>
                </div>
                <div className="En-newspaperContainer">
                  <div className="En-hkej" />
                  <div className="En-ejtech" />
                  <div className="En-hktkww" />
                  <div className="En-wenweipo" />
                </div>
                <div className="En-newspaperContainer">
                  <div className="En-oncc" />
                  <div className="En-techapple" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="En-organizationPage">
          <div className="En-nonprofitContainer">
            <div className="En-nonprofitCircle">
              <div className="En-nonprofitIcn" />
            </div>
            <div className="En-nonprofitTxt">Nonprofit</div>
          </div>
          <div className="En-orgText">Trusted by Many Nonprofits</div>
          <div className="En-organizations">
            <a
              href="https://cbnhk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-cbnhk" />
            </a>

            <a
              href="https://peacemaker.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-peacemaker" />
            </a>

            <a
              href="https://bbhk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-bbhk" />
            </a>

            <a
              href="https://lovefoundation.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-LF" />
            </a>

            <a
              href="https://cchchk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-cchchk" />
            </a>

            <a
              href="https://charactercity.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-charactercity" />
            </a>

            <a
              href="https://sunriseministry.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-sunriseministry" />
            </a>

            <a
              href="https://sunrisechurch.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-sunrisechurch" />
            </a>

            <a
              href="https://gnci.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-gnci" />
            </a>

            <a
              href="https://networkj.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-networkj" />
            </a>

            <a
              href="https://emmhk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-emmhk" />
            </a>

            <a
              href="https://gfy.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-gfy" />
            </a>

            <a
              href="https://echovalley.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-echovalley" />
            </a>

            <a
              href="https://godsglory.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-godsglory" />
            </a>

            <a
              href="https://nav2000hk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-nav2000hk" />
            </a>

            <a
              href="https://gcchk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-gcchk" />
            </a>

            <a
              href="https://petrosbookroom.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-alo" />
            </a>

            <a
              href="https://elijahmission.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-elijahmission" />
            </a>

            <a
              href="https://4limb.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-direction" />
            </a>

            <a
              href="https://rcsahk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-rcsahk" />
            </a>

            <a
              href="https://ebs.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-ebs" />
            </a>

            <a
              href="https://raphahk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-raphahk" />
            </a>

            <a
              href="https://livinghopeworld.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-livinghope" />
            </a>

            <a
              href="https://footprintgallery.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-footprint" />
            </a>

            <a
              href="https://alayluya.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-alayluya" />
            </a>

            <a
              href="https://crownfinancial.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-crownhk" />
            </a>

            <a
              href="https://psyreligion.check.plus"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-capr" />
            </a>

            <a
              href="https://ecohk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-eco" />
            </a>

            <a
              href="https://senrights.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-senrights" />
            </a>

            <a
              href="https://nytec.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="En-frame En-nytec" />
            </a>
          </div>
        </div>

        <div className="En-orgText">What You Can Do With CheckPlus</div>

        <div className="En-mouseContainer">
          <div className="En-mouseIcn" />
          <div className="En-mouseTxt">Scroll Left or Right</div>
        </div>

        <div className="En-third">
          <div className="En-third-space" />
          <div className="En-thirdContainer">
            <div className="En-third-text-Container">
              <div className="En-iconWithtext">
                <div className="En-third-firstIcnContainer">
                  <div className="En-second-firstIcn" />
                </div>

                <div className="En-third-brandText">Create a payment page</div>
              </div>

              <div className="En-third-description">
                Once you have signed up for the service, CheckPlus will
                automatically create a payment page for you.
              </div>
            </div>

            <div className="En-third-iphone" />
          </div>
          <div className="En-thirdContainer">
            <div className="En-third-text-Container">
              <div className="En-iconWithtext">
                <div className="En-fourth-secondIcnContainer">
                  <div className="En-second-secondIcn" />
                </div>
                <div className="En-third-brandText">
                  Create multiple campaigns
                </div>
              </div>

              <div className="En-third-description">
                Nonprofits can set up multiple fundraising campagins and can
                easily set fundraising goals for their campagins.
              </div>
            </div>

            <div className="En-fourth-iphone" />
          </div>
          <div className="En-transaction-type-container ">
            <div className="En-transaction-type-top">
              <div className="En-donation-payment-switch" />
            </div>
            <div className="En-transaction-type-text-container">
              <div className="En-donation-payment-icons" />
              <div className="En-transaction-type-text">
                Set Transaction Type
              </div>

              <div className="En-transaction-type-description">
                You can set the transaction type to make sure the system
                automatically generates the correct receipt type.
              </div>
            </div>
          </div>
          <div className="En-accept-networks-container">
            <div className="En-cardIcn-circle">
              <div className="En-cardIcn" />
            </div>
            <div className="En-cardTxt">
              Accept Multiple <br />
              Payment Methods{" "}
            </div>

            <div className="En-third-text-Container">
              <div className="En-networkList">
                <div className="En-paymentRow1">
                  <div className="En-visaIcon" />
                  <div className="En-mastercardIcon" />
                  <div className="En-amexIcon" />
                  <div className="En-unionpayIcon" />
                </div>
                <div className="En-paymentRow2">
                  <div className="En-applePay" />
                  <div className="En-googlePay" />
                  <div className="En-payme" />
                </div>
              </div>
            </div>
          </div>
          <div className="En-thirdContainer">
            <div className="En-third-text-Container">
              <div className="En-iconWithtext">
                <div className="En-sixth-fourthIcnContainer">
                  <div className="En-second-fourthIcn" />
                </div>

                <div className="En-third-brandText">
                  Recurring monthly donation
                </div>
              </div>

              <div className="En-third-description">
                Your donors can arrange recurring monthly donation, and
                CheckPlus will take care of the rest.
              </div>
            </div>

            <div className="En-frequency" />
          </div>
          <div className="En-thirdContainer">
            <div className="En-third-text-Container">
              <div className="En-iconWithtext-noDescription">
                <div className="En-fifth-fifthIcnContainer">
                  <div className="En-second-fifthIcn" />
                </div>

                <div className="En-third-brandText">Donor’s Membership</div>
              </div>
            </div>

            <div className="En-fifth-iphoneLeft" />
          </div>

          <div className="En-thirdContainer">
            <div className="En-third-text-Container">
              <div className="En-iconWithtext-noDescription">
                <div className="En-fifth-fifthIcnContainer2">
                  <div className="En-second-sixthIcn" />
                </div>

                <div className="En-third-brandText">
                  Collect Donor’s data during payment
                </div>
              </div>
            </div>

            <div className="En-fifth-iphoneRight" />
          </div>
          <div className="En-thirdContainer">
            <div className="En-third-text-Container">
              <div className="En-iconWithtext">
                <div className="En-receipt-seventhIcnContainer">
                  <div className="En-second-seventhIcn" />
                </div>
                <div className="En-third-brandText">
                  Automatic Receipt Handling
                </div>
              </div>
              <div className="En-third-description">
                The system automatically sends out official receipts to
                payers/donors shortly after their payments/donations.
              </div>
            </div>

            <div className="En-receiptSample" />
          </div>
          <div className="En-thirdContainer">
            <div className="En-reports-features" />
            <div className="En-third-text-Container">
              <div className="En-iconWithtext">
                <div className="En-reports-eighthIcnContainer">
                  <div className="En-second-eighthIcn" />
                </div>

                <div className="En-third-brandText">
                  Generate a report anytime
                </div>
              </div>

              <div className="En-third-description">
                You can request the system to generate a report anytime in the
                organization dashboard.
              </div>
            </div>
          </div>
          <div className="En-thirdContainer">
            <div className="En-banks">
              <div className="En-banksContainer">
                <div className="En-bankText">
                  All licensed banks of the Hong Kong Monetary Authority are
                  supported.
                </div>

                <div className="En-bankList">
                  <a
                    href="https://www.hsbc.com.hk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="En-hsbc" />
                  </a>

                  <a
                    href="https://www.bochk.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="En-boc" />
                  </a>

                  <a
                    href="https://www.hangseng.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="En-hsb" />
                  </a>

                  <a
                    href="https://www.sc.com/hk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="En-sc" />
                  </a>

                  <a
                    href="https://www.icbcasia.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="En-icbc" />
                  </a>

                  <a
                    href="https://www.citibank.com.hk"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="En-citi" />
                  </a>

                  <a
                    href="https://www.dbs.com.hk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="En-dbs" />
                  </a>

                  <a
                    href="https://www.hkbea.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="En-bea" />
                  </a>
                </div>

                <div className="En-bankNextContainer">
                  <a
                    href="https://www.hkicl.com.hk/eng/information_centre/clearing_code_and_branch_code_list.php"
                    className="En-bankNextText"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    More Banks
                  </a>
                  <div className="En-bankNextArrow" />
                </div>
              </div>
            </div>
          </div>
          <div className="En-third-space2" />
        </div>

        <div className="En-privacy">
          <div className="En-privacyContainer">
            <div className="En-privacyIcn" />
            <div className="En-privacyTxt">Privacy</div>
            <div className="En-privacyDescription">
              Your data should be yours.
            </div>
            <Link to="/EnPrivacy">
              <div className="En-privacyBtn">
                <div className="En-privacyBtnTxt">Learn More</div>
                <div className="En-privacyNext" />
              </div>
            </Link>
          </div>
        </div>

        <div className="En-tenth">
          <div className="En-tenth_container">
            <div className="En-tenth-innerContainer">
              <div className="En-tenth-text1">
                We have created a brochure for you so that you can learn more
                about our service.
              </div>
              <div className="En-brochureBtn">
                <div className="En-brochureBtn-container">
                  <div className="En-brochureIcn" />
                  <a
                    href="https://drive.google.com/file/d/1O60Xz6mIkK7jmH5fZvwFlQ6_4v2Fj1YT/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="En-brochureTxt">
                      Download Brochure [PDF]
                    </div>
                  </a>
                </div>
              </div>
              <br />
              <div className="En-tenth-text1">
                Need more information? We can meet with you one-on-one too!
              </div>
              <div className="En-meetBtn">
                <div className="En-brochureBtn-container">
                  <div className="En-meetIcn" />
                  <a
                    href="https://forms.gle/UJ4yasfAtMvqEBeHA"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="En-brochureTxt">Meet with us</div>
                  </a>
                </div>
              </div>
              <br />
              <div className="En-tenth-text1">
                If you are ready, feel free to sign up anytime.
              </div>
              <div className="En-registerBtn">
                <div className="En-registerBtn-container">
                  <div className="En-registerIcn" />
                  <Link to="/OrgSignup">
                    <div className="En-registerTxt">Sign Up</div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="En-tenth-iphone" />
          </div>
        </div>

        <div className="En-footer">
          <div className="En-footerNav">
            <Link to="/EnTeam">
              <div className="En-footerNavItem">Our Founders</div>
            </Link>

            <Link to="/EnFaq">
              <div className="En-footerNavItem">FAQ</div>
            </Link>

            <Link to="/EnContact">
              <div className="En-footerNavItem">Contact Us</div>
            </Link>

            <Link to="/EnPrivacyPolicy">
              <div className="En-footerNavItem">Privacy Policy</div>
            </Link>

            <Link to="/EnTerms">
              <div className="En-footerNavItem">Terms and Conditions</div>
            </Link>
          </div>

          <div className="En-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default En;
